<template>

    <div v-if="user && user.features.agency" class="agency-banner" :class="{ collapsed }">
        <div v-if="!collapsed" class="agency-banner-inner">
            <v-button-icon
                icon="fas fa-chevrons-up"
                width="30px"
                height="30px"
                icon-size="10px"
                :title="$t('labels.collapse')"
                @click.native="toggle"
            />
            <v-button-toolbar v-if="user.agency" size="sm">
                <v-dropdown-agency size="xs" />
                <v-button
                    theme="white"
                    size="xs"
                    @click.native="$router.push({ name: 'agency.settings', params: { id: user.agency.id } })"
                >
                    {{ $t('labels.settings') }}
                </v-button>
            </v-button-toolbar>
            <v-button
                v-else
                theme="white"
                size="xs"
                @click.native="$router.push({ name: 'agency.create' })"
            >
                {{ $t('labels.create_agency') }}
            </v-button>
        </div>
        <button
            v-else
            type="button"
            class="agency-banner-expand"
            :aria-label="$t('labels.expand')"
            :title="$t('labels.expand')"
            @click="toggle"
        >
            <i class="fas fa-chevrons-down" aria-hidden="true" />
        </button>
    </div>

</template>

<style scoped lang="scss">

    .agency-banner {
        background: $color-primary;
        color: $color-white;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        z-index: 600;
    }

    .agency-banner-inner {
        align-items: center;
        display: flex;
        justify-content: space-between;
        padding: 5px 15px;
        width: 100%;
    }

    .agency-banner.collapsed {
        height: 3px;
    }

    .agency-banner-expand {
        align-items: center;
        appearance: none;
        background: $color-primary;
        border: none;
        border-radius: 0 0 5px 5px;
        color: $color-white;
        cursor: pointer;
        display: inline-flex;
        font-size: 10px;
        height: 18px;
        justify-content: center;
        left: 15px;
        line-height: 1;
        outline: none;
        padding: 0 8px;
        position: absolute;
        top: 3px;
        transition: transform .3s ease;
        z-index: 1;

        &::before {
            background: $color-primary;
            content: '';
            height: 6px;
            left: 0;
            position: absolute;
            right: 0;
            top: -3px;
        }

        &:hover {
            transform: translateY(3px);
        }
    }

</style>

<script>

import DropdownAgency from '@cmp/DropdownAgency';

const STORAGE_KEY = 'agency_banner_collapsed';

export default {

    components: {
        'v-dropdown-agency': DropdownAgency,
    },

    data() {
        return {
            collapsed: localStorage.getItem(STORAGE_KEY) === '1',
        };
    },

    methods: {

        toggle() {
            this.collapsed = !this.collapsed;
            localStorage.setItem(STORAGE_KEY, this.collapsed ? '1' : '0');
        },

    },

}

</script>
